<template>
	<div style="background-color: #fff;padding: 5px 10px;height: 40px;border-bottom: 1px solid #e1e1e1;">
		<el-row justify="start">
			<!-- <el-col :span="6" >
				<div>&nbsp;</div>
			</el-col> -->
			<el-col :span="21">
				<div style="text-align: center;font-weight: 800;margin-top: 10px;">&nbsp;{{systemname}}&nbsp;</div>
			</el-col>
			<el-col :span="3">
				<div style="margin-top: 0px;line-height: 28px;height: 28px;float: right;margin-right: 10px;min-width: 180px;">
					<!-- <span style=""><i style="color: #797979;font-size: 20px;" class="el-icon-bell"></i></span> -->
					<span style="margin-left: 20px;"><i style="color: #797979;font-size: 20px;" class="el-icon-user"></i></span>
					<span style="margin-left: 5px;color: #797979;font-size: 14px;line-height: 40px;">{{userInfo.realname}}</span>
					<span style="margin-left: 10px;color: #797979;font-size: 20px;">
						<el-divider style="margin-left: 20px;" direction="vertical"></el-divider>
					</span>
					<!-- <span style="margin-left: 10px;color: #797979;font-size: 14px;" @click="changepwd">修改密码</span> -->
					<span style="margin-left: 10px;color: #797979;font-size: 14px;" @click="logOut">
						<i style="color: #FC988B;font-size: 20px;" class="el-icon-switch-button"></i>
						退出
					</span>
				</div>
				
			</el-col>
		</el-row>
		
	</div>
</template>

<script>
	//import { sysname } from '/public/sysname'
	export default {
		name : 'SysHeader',
		data() {
			return {
				bgcolor : '#FFF  !important',
				isCollapse: false,
				userInfo : {
					realname : ''
				},
				systemname : ''
			}
		},
		mounted() {
			let uinfo = localStorage.getItem("bUserinfo")
			this.userInfo = JSON.parse(uinfo)
			this.systemname = localStorage.getItem("cityname")
		},
		methods: {
			logOut(){
				console.log('退出')
				localStorage.setItem("citycode", '')
				localStorage.setItem("cityname", '')
				localStorage.setItem("bUserinfo", '')
				sessionStorage.setItem("authToken", '');
				this.$router.push({ name: 'Login' });
			},
			
			changepwd(){
				this.$router.push({ name: 'ChangePassword' });
				
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	.yh-menu-icon-color{
		color: #fff;
	}
</style>